import { handleDiscountApplication } from '../../../utils/discountHelper';

/**
 * Applying a code to the price on screen.
 *
 * Only the display changes. The code itself is carried into the checkout session in
 * a hidden field, and the server prices the order: a number edited in the page is
 * never what gets charged. How the new price is shown is the caller's, through
 * onApplied.
 *
 * The sentences arrive from the page, already translated, with :percent and
 * :seconds left to fill.
 */

const REFUSAL_COUNTDOWN = 3;

function el(id) {
    return document.getElementById(id);
}

/**
 * Counts down rather than clearing at once: a refusal that vanishes immediately
 * reads as nothing having happened, and the box is held shut for those seconds.
 */
function refuse(messageBox, input, sentence) {
    let left = REFUSAL_COUNTDOWN;
    const say = () => {
        messageBox.innerText = sentence.replace(':seconds', left);
    };

    if (input) {
        input.disabled = true;
    }

    say();

    const ticking = setInterval(() => {
        left -= 1;

        if (left > 0) {
            say();

            return;
        }

        clearInterval(ticking);
        messageBox.innerText = '';

        if (input) {
            input.disabled = false;
        }
    }, 1000);
}

export function applyDiscount({ promoApi, plan, bookSlug, basePrice, code, button, messages, onApplied, upgrade, onGranted }) {
    if (! code) {
        return Promise.resolve();
    }

    el('discountMessage').innerText = '';
    el('discountMessageSuccess').innerText = '';

    return handleDiscountApplication({
        promoApi,
        payload: {
            discount_code: code,
            book_slug: bookSlug,
            subscription_type: plan,
            base_price: basePrice,
            ...upgrade
        },
        button,
        loadingText: button
            ? '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
            : null,
        onSuccess: (data) => {
            // A registration code answers with the days it grants, not a price, and
            // only on the upgrade page, which is the one that says what that means.
            if (data.access_days) {
                onGranted?.(data.access_days);

                return;
            }

            el('discountMessageSuccess').innerText = messages.applied.replace(':percent', data.discount_percentage);
            el('appliedDiscountCode').value = code;

            onApplied?.(data.new_price);
        },
        onFailure: () => refuse(el('discountMessage'), el('discount_code'), messages.refused)
    });
}
